import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/approvalType/main"));

const ApprovalType = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default ApprovalType;


